export default __webpack_public_path__ + "static/media/241.dbbd61b1.jpg";